export const constants = {
  getConfirmationDetailsEndPoint: '/pages/sms/ess/v3/ws/rest/pub/ssr/confirmation/getConfirmationData',
  logProductUrlEndPoint: '/pages/sms/ess/v3/ws/rest/pub/ssr/confirmation/logProductUrl',
  PATHCONFIRMATION: '/ssr/PIC/confirmation',
};